import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDoctors, downloadData } from "../../../db/users";
import { AuthContext } from "../../../context/AuthContext";
import {
  convertObjectToArray,
  orderArrayByStringProperty,
} from "../../../util/arraysUtil";
import { IoMdAddCircle } from "react-icons/io";
import Container from "../../../ui/Container/Container";
import Button from "../../../ui/Button/Button";
import List from "../../../ui/List/List";

import "./MainAdmin.css";

function MainAdminScreen() {
  const authCtx = useContext(AuthContext);
  const [isFetching, setIsFetching] = useState(true);
  const [fullData, setFullData] = useState([]);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchDoctors() {
      setIsFetching(true);
      const response = await getDoctors(authCtx.token);
      let dataArray = convertObjectToArray(response.data);
      dataArray = dataArray.filter((da) => da.role === "Doctor");
      setData(dataArray);
      setIsFetching(false);
      setFullData(dataArray);
    }
    try {
      fetchDoctors();
    } catch (error) {
      console.log(error);
    }
  }, []);

  function handleSearch(e) {
    const query = e.target.value;
    setSearchQuery(query);
    const formattedQuery = query.toLowerCase();
    const filteredData = fullData.filter((item) => {
      const fullName = `${item.name} ${item.lastName} ${item.surName}`;
      return fullName.toLowerCase().includes(formattedQuery);
    });
    setData(filteredData);
  }

  function generateData() {
    let doctorList = data.map((doctor) => {
      return {
        key: doctor.key,
        value: `${doctor.name} ${doctor.lastName} ${doctor.surName}`,
        navigateTo: "/doctorInfo",
        route: { doctor },
      };
    });
    doctorList = orderArrayByStringProperty(doctorList, "value");
    return doctorList;
  }

  function addDoctorHandler() {
    navigate("/createDoctor");
  }

  async function refreshHandler() {
    setIsFetching(true);
    const response = await getDoctors(authCtx.token);
    let dataArray = convertObjectToArray(response.data);
    dataArray = dataArray.filter((da) => da.role === "Doctor");
    setData(dataArray);
    setIsFetching(false);
    setFullData(dataArray);
  }

  async function onDownloadHandler() {
    const resp = await downloadData();
    const outputFilename = "siennadata.xlsx";
    const bloby = new Blob([resp.data]);
    const url = URL.createObjectURL(bloby);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", outputFilename);
    document.body.appendChild(link);
    link.click();
  }

  if (isFetching) {
    return <p>Cargando información de los doctores...</p>;
  }

  return (
    <Container title={"Opciones de administrador"}>
      <div className="messageAndButton">
        <div>
          <p className="title">Crear nuevo doctor</p>
        </div>
        <div className="add">
          <div onClick={addDoctorHandler}>
            <IoMdAddCircle
              style={{ fontSize: "48px", padding: "8px", color: "#FF2600" }}
            />
          </div>
        </div>
      </div>
      <div style={{ width: "100%", justifyItems: "center" }}>
        <div className="refreshContainer">
          <div style={{ marginBottom: "10px" }}>
            <Button onPress={refreshHandler}>Actualizar información</Button>
          </div>
          <div>
            <Button onPress={onDownloadHandler}>Descargar datos</Button>
          </div>
        </div>
      </div>
      {data && (
        <div className="innerContainer">
          <input
            placeholder="Buscar doctor..."
            className="filter"
            autoCapitalize="none"
            onChange={handleSearch}
          />

          <List data={generateData()} height="80%" />
        </div>
      )}
    </Container>
  );
}

export default MainAdminScreen;
